// extracted by mini-css-extract-plugin
export var logo = "style-module--logo--e7e41";
export var percent = "style-module--percent--fb9cd";
export var percentSign = "style-module--percentSign--af932";
export var wrap = "style-module--wrap--64e1b";